// extracted by mini-css-extract-plugin
module.exports = {"useMapBlock":"UseMapBlock_useMapBlock__I_Uvb","locationIcon":"UseMapBlock_locationIcon__rGQWe","title":"UseMapBlock_title__jfJbA","subtitle":"UseMapBlock_subtitle__ysi3c"};